import { render, staticRenderFns } from "./CBusy.vue?vue&type=template&id=54676b4e&scoped=true&"
import script from "./CBusy.vue?vue&type=script&lang=js&"
export * from "./CBusy.vue?vue&type=script&lang=js&"
import style0 from "./CBusy.vue?vue&type=style&index=0&id=54676b4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54676b4e",
  null
  
)

export default component.exports